import { styled } from '@mui/material/styles';

export const StyledTableWrapper = styled('div')`
  overflow: auto;
  width: 100%;
`;